import { useEffect, useState } from "react";
import { get, Card, fmtDate, Empty } from "./shared";

const ACTIONS = {
  order_status: "Statut de commande", order_refund: "Remboursement", message_reply: "Réponse à un message",
  review_approve: "Avis publié", review_hide: "Avis masqué", review_delete: "Avis supprimé",
  stock_update: "Stock modifié", settings_update: "Paramètres modifiés", stock_alerts_sent: "Alertes retour en stock envoyées",
  page_create: "Page créée", page_update: "Page modifiée", page_delete: "Page supprimée",
};

export const Activity = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { get("/activity").then(setRows).catch(() => setRows([])); }, []);
  if (rows === null) return <Empty>Chargement…</Empty>;
  if (rows.length === 0) return <Empty>Aucune action enregistrée pour le moment.</Empty>;
  return (
    <Card className="divide-y divide-stone-100" data-testid="admin-activity">
      {rows.map((a) => (
        <div key={a.id} className="px-5 py-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
          <span className="text-xs font-mono text-stone-400 w-36">{fmtDate(a.at, true)}</span>
          <span className="text-stone-900 w-48">{ACTIONS[a.action] || a.action}</span>
          <span className="font-mono text-xs text-[#C85A32]">{a.target}</span>
          <span className="text-stone-500 flex-1">{a.details}</span>
          <span className="text-[10px] font-mono text-stone-400">{a.admin}</span>
        </div>
      ))}
    </Card>
  );
};
